<template>
  <div class="item-recommended">
    <div class="cover">
      <img
        class="h-40 w-full object-cover"
        :src="getItemDataImageUrl"
        :alt="getItemDataImageExp"
        @click="gotoMenuDetails()"
      />
    </div>
    <div class="content">
      <div class="label label-grey-200 text-primary" v-if="recommendedData.categoryInfomation && recommendedData.category">
        {{ recommendedData.category }}
      </div>
      <div class="item-id">
        <span>[メニューNo. {{ recommendedData.menuNo }} ]</span>
      </div>
      <div class="item-title">
        <a @click="gotoMenuDetails()">
          <h4>{{ recommendedData.menuNm }}</h4>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'RecommendedItem',
  props: {
    recommendedData: {
      type: Object,
      default() {
        return {
          menuImages: [
            {
              imageUrl: require('@/assets/images/mypage/soup.jpg'),
              imageExplanation: null
            },
            {
              imageUrl: require('@/assets/images/mypage/soup.jpg'),
              imageExplanation: null
            }
          ],
          category: 'アジア・エスニック',
          menuNo: '123456',
          menuNm: 'ブーゲンビリア',
          discount: 'お会計時に10%OFF',
          expiry: '利用期限 2021/06/30'
        }
      }
    }
  },
  data() {
    return {
    
    }
  },
  computed: {
    getItemDataImageUrl() {
      const url = _.get(this.recommendedData, 'menuImages[0].imageUrl', null)
      if(url) {
        return url
      }
      return require('@/assets/images/slide-img-placeholder.png')
    },
    getItemDataImageExp() {
      return _.get(this.recommendedData, 'menuImages[0].imageExplanation', null)
    }
  },
  methods: {
    gotoMenuDetails() {
      const query = this.$route.query
      this.$router.push({path: `/menus/${this.recommendedData.menuNo}`, query})
    }
  }
  
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>